var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.938 16.271a2.917 2.917 0 1 1 3.312 4.698v3.198a1.25 1.25 0 0 1-2.5 0v-3.198a2.915 2.915 0 0 1-.812-4.698m2.076 2.48L20 18.75h-.014a.416.416 0 1 1 .028 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.172 4.064a1.25 1.25 0 0 1 1.656 0A18.75 18.75 0 0 0 34.11 8.75a1.25 1.25 0 0 1 1.257.896A21.25 21.25 0 0 1 20.314 36.21a1.25 1.25 0 0 1-.628 0A21.25 21.25 0 0 1 4.634 9.647a1.25 1.25 0 0 1 1.256-.896 18.75 18.75 0 0 0 13.282-4.687M6.788 11.27A18.75 18.75 0 0 0 20 33.706 18.75 18.75 0 0 0 33.212 11.27 21.25 21.25 0 0 1 20 6.632a21.25 21.25 0 0 1-13.212 4.639",
    clipRule: "evenodd"
  })));
};
export default SvgSecurity;